import {
    useEffect,
    useState,
    useRef,
    type FC
} from "react";
import {
    type ISelectBoxRef,
    type SelectedItem
} from "../../../selectBox/type";
import type INativeSelectProps from "../../type";
import {
    type NativeSelectItem
} from "../../type";
import SelectBox from "../../../selectBox";

const NativeSelectSheet: FC<INativeSelectProps> = ({
    value: valueProp,
    initialValue,
    onChange,
    data,
    ...props
}) => {
    const selectBoxRef = useRef<ISelectBoxRef<NativeSelectItem> | null>(null);

    const [
        internalValue,
        setInternalValue
    ] = useState(initialValue ?? "");

    const currentValue = valueProp ?? internalValue;

    const currentValueRef = useRef(currentValue);

    currentValueRef.current = currentValue;

    const getSelectedItems = (value: string): Array<SelectedItem> => {
        const currentItem = data.find((item) => item.value === value);

        if(!currentItem) {
            return [];
        }

        return [
            {
                __title: currentItem.title,
                __key: currentItem.value
            }
        ];
    };

    useEffect(() => {
        if(valueProp === undefined) {
            return;
        }

        selectBoxRef.current?.updateSelections(getSelectedItems(valueProp));
    }, [
        valueProp
    ]);

    const onSelectBoxChange = (selectedItems: Array<SelectedItem>) => {
        const nextValue = selectedItems[0]?.__key;

        if(nextValue === undefined || nextValue === currentValueRef.current) {
            return;
        }

        setInternalValue(nextValue);

        if(onChange) {
            onChange(nextValue);
        }
    };

    return <SelectBox<NativeSelectItem>
        defaultValue={getSelectedItems(currentValue)[0]?.__key ?? ""}
        titleExtractor={(item) => item.title}
        removeSelectValidation={() => false}
        keyExtractor={(item) => item.value}
        isShowSelectSheetTools={false}
        onChange={onSelectBoxChange}
        isMultipleSelect={false}
        isSearchable={false}
        ref={selectBoxRef}
        data={data}
        {...props}
    />;
};
export default NativeSelectSheet;
